import React, { useEffect, useState } from 'react';
import ajaxChargeRate from '../util/remote/ajaxChargeRate';
import ajaxBank from '../util/remote/ajaxBank';

const RateContext = React.createContext();

export const RateConsumer = RateContext.Consumer;

export const RateProvider = (props)=> {

   
   const [rateList, setRateList] = useState(false);
   const [typeList, setTypeList] = useState(false);
   const [schoolRates, setSchoolRates] = useState(false);
   const [globalPocketMoneySettings, setGlobalPocketMoneySettings] = useState(false);
   const [schoolPocketMoneySettings, setSchoolPocketMoneySettings] = useState(false);
   const [vendorPocketMoneySettings, setVendorPocketMoneySettings] = useState(false);
   const [loading, setLoading] = useState(false);
   const [transactionHighlights, setTransactionHighlights] = useState([]);
   const [depositRates, setDepositRates] = useState(false);
   const [commissionPercentages, setCommissionPercentages] = useState(false);


   useEffect(() => {
           getTransactionHighlights();
   }, []);
  
   const getRateList =async()=>{

      const server_response = await ajaxChargeRate.fetchChargeRateList();
      if(server_response.status==="OK"){
         //store results
         setRateList(server_response.details);
      }else{
         //communicate error
         setRateList("404");
      }
   }

   const getTypeList =async()=>{

      const server_response = await ajaxChargeRate.fetchChargeTypeList();
      if(server_response.status==="OK"){
         //store results
         setTypeList(server_response.details);
      }else{
         //communicate error
         setTypeList("404");
      }
   }

   const getSchoolRates = async () => {
      setLoading(true)
      const server_response = await ajaxChargeRate.fetchSchoolRateList();
      setLoading(false)
      if (server_response.status === "OK") {
        setSchoolRates(server_response.details);
      }else {
        setSchoolRates("404");
      }
    };

    const getGlobalPocketMoneySettings =async()=>{

      const server_response = await ajaxChargeRate.fetchGlobalPocketMoneySettings();
      if(server_response.status==="OK"){
         //store results
         setGlobalPocketMoneySettings(server_response.details);
      }else{
         //communicate error
         setGlobalPocketMoneySettings("404");
      }
   }

   const getSchoolPocketMoneySettings =async()=>{

      const server_response = await ajaxChargeRate.fetchSchoolPocketMoneySettings();
      if(server_response.status==="OK"){
         //store results
         setSchoolPocketMoneySettings(server_response.details);
      }else{
         //communicate error
         setSchoolPocketMoneySettings("404");
      }
   }

   const getVendorPocketMoneySettings =async()=>{

      const server_response = await ajaxChargeRate.fetchVendorPocketMoneySettings();
      if(server_response.status==="OK"){
         //store results
         setVendorPocketMoneySettings(server_response.details);
      }else{
         //communicate error
         setVendorPocketMoneySettings("404");
      }
   }

   const getTransactionHighlights = async () => {
         const server_response = await ajaxBank.fetchPocketMoneyHighlights();
         if (server_response.status === "OK") {
           //store results
           setTransactionHighlights(server_response.details);
         } else {
           //communicate error
           setTransactionHighlights([]);
         }
   };

   const getDepositRates =async()=>{

      const server_response = await ajaxChargeRate.fetchCanteenDepositRates();
      if(server_response.status==="OK"){
         //store results
         setDepositRates(server_response.details);
      }else{
         //communicate error
         setDepositRates("404");
      }
   }

   const getCommissionPercentages =async()=>{

      const server_response = await ajaxChargeRate.fetchCommissionPercentages();
      if(server_response.status==="OK"){
         //store results
         setCommissionPercentages(server_response.details);
      }else{
         //communicate error
         setCommissionPercentages("404");
      }
   }
    
    return (
           <RateContext.Provider value={
               {
                    rateList,
                    typeList,
                    schoolRates,
                     depositRates,
                    loading,
                     globalPocketMoneySettings,
                     schoolPocketMoneySettings,
                     vendorPocketMoneySettings,
                     transactionHighlights,
                     commissionPercentages,
                  getRateList,
                  getTypeList,
                  getSchoolRates,
                  getGlobalPocketMoneySettings,
                  getSchoolPocketMoneySettings,
                  getVendorPocketMoneySettings,
                  getTransactionHighlights,
                  getDepositRates,
                  getCommissionPercentages
               }
               }>
               {props.children}
           </RateContext.Provider>
        );
    
}

export default RateContext;